import { useEffect } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { useBoolean } from 'usehooks-ts';
import LoadingCircle from '@/components/loading-circle';
import SuccessGambling from '@/components/success-gambling';
import SuccessText from '@/components/succes-text';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { GeneralSlice } from '@/redux/general';
import { SliderSlice } from '@/redux/slider';
import { UserFormSlice } from '@/redux/user-form';
import Condition from '@/utils/condition';
import '@/components/result-page/result-page-v1.css';
import '@/components/result-page/result-page-v2.css';

const MotionLoadingCircle = motion.create(LoadingCircle);

export default function ResultPage() {
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const prefix = useAppSelector(ConfigSlice.selectors.prefix);
  const isSuccessful = useAppSelector(SliderSlice.selectors.isFormSubmissionSuccessful);
  const isFailed = useAppSelector(SliderSlice.selectors.isFormSubmissionFailed);
  const answersDirect = useAppSelector(SliderSlice.selectors.answersDirect);
  const allQuestions = useAppSelector(SliderSlice.selectors.questionsAll);
  const fullName = useAppSelector(UserFormSlice.selectors.fullName);
  const userEmail = useAppSelector(UserFormSlice.selectors.email);
  const userFormHeight = useAppSelector(GeneralSlice.selectors.userFormHeight);
  const { value: isReady, setTrue: markReady } = useBoolean(false);

  useEffect(() => {
    if (!isSuccessful && !isFailed) return;
    setTimeout(() => markReady(), 1000);
  }, [isSuccessful, isFailed]);

  return (
    <div
      data-css-version={cssVersion}
      style={{ minHeight: cssVersion === 2 && !isReady ? userFormHeight : 'initial' }}
      className='result-page'
    >
      {cssVersion === 1 ? (
        <>
          <div className='result-page__loading'>
            <LoadingCircle success={isSuccessful} fail={isFailed} />
          </div>
          {['SWE'].includes(Condition.getFirst(prefix, '')) ? (
            <SuccessGambling answers={answersDirect} questions={allQuestions} fullName={fullName} email={userEmail} />
          ) : (
            <SuccessText />
          )}
        </>
      ) : (
        <AnimatePresence>
          {!isReady ? (
            <div className='result-page__loading'>
              <MotionLoadingCircle
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5, delay: 0 }}
                success={isSuccessful}
                fail={isFailed}
              />
            </div>
          ) : (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5, delay: 0.25 }}
              className='result-page__content'
            >
              {['SWE'].includes(Condition.getFirst(prefix, '')) ? (
                <SuccessGambling
                  answers={answersDirect}
                  questions={allQuestions}
                  fullName={fullName}
                  email={userEmail}
                />
              ) : (
                <SuccessText />
              )}
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </div>
  );
}
